var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "main-content" }, [
    _c("div", { staticClass: "card" }, [
      _c("div", { staticClass: "card-header" }, [
        _c("h5", { staticClass: "inline" }, [
          _vm._v("\n        Список запросов\n        "),
          _vm.request.deleted == "0"
            ? _c("span", [_vm._v("на обратный звонок")])
            : _c("span", [_vm._v("в корзине")]),
        ]),
        _vm._v(" "),
        _c(
          "ul",
          { staticClass: "nav nav-tabs card-header-tabs" },
          _vm._l(_vm.sites, function (site) {
            return _c("li", { staticClass: "nav-item" }, [
              _c(
                "a",
                {
                  staticClass: "nav-link",
                  class: _vm.request.site_id == site.id ? "active" : "",
                  attrs: { href: "#" + site.id },
                  on: {
                    click: function ($event) {
                      return _vm.getItems({
                        site_id: site.id,
                        deleted: _vm.basket,
                      })
                    },
                  },
                },
                [
                  _vm._v(
                    "\n            " + _vm._s(site.name) + "\n            "
                  ),
                  site.qty
                    ? _c("span", { staticClass: "badge badge-secondary" }, [
                        _vm._v(_vm._s(site.qty)),
                      ])
                    : _vm._e(),
                ]
              ),
            ])
          }),
          0
        ),
      ]),
      _vm._v(" "),
      _vm.sites.length
        ? _c("div", { staticClass: "card-body" }, [
            _c("table", { staticClass: "table" }, [
              _vm._m(0),
              _vm._v(" "),
              _c(
                "tbody",
                _vm._l(_vm.items, function (item, index) {
                  return _c(
                    "tr",
                    {
                      key: item.id,
                      class: item.status == "called" ? "called" : "",
                    },
                    [
                      _c("th", [_vm._v(_vm._s(item.id))]),
                      _vm._v(" "),
                      _c("td", [_vm._v(_vm._s(item.name))]),
                      _vm._v(" "),
                      _c("td", [
                        item.phone && item.phone != "не указан"
                          ? _c(
                              "div",
                              {
                                staticClass: "flex",
                                staticStyle: { "align-items": "baseline" },
                              },
                              [
                                _c(
                                  "MakeCall",
                                  {
                                    attrs: {
                                      phone: {
                                        phone: item.phone.replace(
                                          /[^0-9]/g,
                                          ""
                                        ),
                                      },
                                      order: {
                                        id: 0,
                                        client_id: 0,
                                        site_id: _vm.request.site_id,
                                        city_id: 0,
                                      },
                                    },
                                  },
                                  [
                                    _vm._t("btn", function () {
                                      return [
                                        _c(
                                          "button",
                                          {
                                            staticClass:
                                              "btn btn-success btn-xs call_btn",
                                            attrs: { type: "button" },
                                          },
                                          [
                                            _c("i", {
                                              staticClass:
                                                "icon-fa icon-fa-phone-square",
                                            }),
                                          ]
                                        ),
                                      ]
                                    }),
                                  ],
                                  2
                                ),
                                _vm._v(" "),
                                _c("span", { staticClass: "ml-2" }, [
                                  _vm._v(_vm._s(item.phone)),
                                ]),
                              ],
                              1
                            )
                          : _c("span", [_vm._v("не указан")]),
                      ]),
                      _vm._v(" "),
                      _c("td", [_vm._v(_vm._s(item.city))]),
                      _vm._v(" "),
                      _c("td", [
                        _c("textarea", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: item.comment,
                              expression: "item.comment",
                            },
                          ],
                          staticClass: "form-control form-control-sm",
                          domProps: { value: item.comment },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) return
                              _vm.$set(item, "comment", $event.target.value)
                            },
                          },
                        }),
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        item.product
                          ? _c("a", { attrs: { href: item.product.url } }, [
                              _vm._v(_vm._s(item.product.name)),
                            ])
                          : _vm._e(),
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _c(
                          "select",
                          {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: item.status,
                                expression: "item.status",
                              },
                            ],
                            staticClass: "form-control form-control-sm",
                            on: {
                              change: function ($event) {
                                var $$selectedVal = Array.prototype.filter
                                  .call($event.target.options, function (o) {
                                    return o.selected
                                  })
                                  .map(function (o) {
                                    var val = "_value" in o ? o._value : o.value
                                    return val
                                  })
                                _vm.$set(
                                  item,
                                  "status",
                                  $event.target.multiple
                                    ? $$selectedVal
                                    : $$selectedVal[0]
                                )
                              },
                            },
                          },
                          [
                            _c("option", { attrs: { value: "" } }, [
                              _vm._v("Ждет звонка"),
                            ]),
                            _vm._v(" "),
                            _c("option", { attrs: { value: "recall" } }, [
                              _vm._v("Позвонить повторно"),
                            ]),
                            _vm._v(" "),
                            _c("option", { attrs: { value: "called" } }, [
                              _vm._v("Дозвонились"),
                            ]),
                            _vm._v(" "),
                            _c("option", { attrs: { value: "not_called" } }, [
                              _vm._v("Не дозвонились"),
                            ]),
                          ]
                        ),
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _vm._v(
                          _vm._s(
                            _vm.printDate(item.created_at, "DD.MM.YYYY HH:mm")
                          )
                        ),
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _vm.loaded
                          ? _c("div", [
                              _vm.request.deleted == "0"
                                ? _c("div", [
                                    _c(
                                      "button",
                                      {
                                        staticClass: "btn btn-xs btn-danger",
                                        staticStyle: { margin: "0 5px" },
                                        attrs: {
                                          type: "button",
                                          title: "В корзину",
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.removeItem(
                                              item.id,
                                              index
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c("i", {
                                          staticClass:
                                            "icon-fa icon-fa-trash-o",
                                          attrs: { "aria-hidden": "true" },
                                        }),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "button",
                                      {
                                        staticClass: "btn btn-xs btn-success",
                                        attrs: {
                                          type: "button",
                                          title: "Сохранить",
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.updateItem(item, index)
                                          },
                                        },
                                      },
                                      [
                                        _c("i", {
                                          staticClass: "icon-fa icon-fa-save",
                                          attrs: { "aria-hidden": "true" },
                                        }),
                                      ]
                                    ),
                                  ])
                                : _c("div", [
                                    _c(
                                      "button",
                                      {
                                        staticClass: "btn btn-xs btn-success",
                                        attrs: {
                                          type: "button",
                                          title: "Сохранить",
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.restoreItem(
                                              item.id,
                                              index
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n                  Восстановить\n                "
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "button",
                                      {
                                        staticClass: "btn btn-xs btn-danger",
                                        staticStyle: { margin: "0 5px" },
                                        attrs: {
                                          type: "button",
                                          title: "Удалить безвозвратно",
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.destroyItem(
                                              item.id,
                                              index
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c("i", {
                                          staticClass:
                                            "icon-fa icon-fa-trash-o",
                                          attrs: { "aria-hidden": "true" },
                                        }),
                                      ]
                                    ),
                                  ]),
                            ])
                          : _vm._e(),
                      ]),
                    ]
                  )
                }),
                0
              ),
            ]),
            _vm._v(" "),
            _vm.loaded
              ? _c("div", [
                  _vm.request.deleted == "0"
                    ? _c("div", {}, [
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-info",
                            attrs: { type: "button" },
                            on: {
                              click: function ($event) {
                                return _vm.getItems({
                                  site_id: _vm.request.site_id,
                                  deleted: "1",
                                })
                              },
                            },
                          },
                          [_vm._v("Запросы в корзине")]
                        ),
                      ])
                    : _c("div", {}, [
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-info",
                            attrs: { type: "button" },
                            on: {
                              click: function ($event) {
                                return _vm.getItems({
                                  site_id: _vm.request.site_id,
                                  deleted: "0",
                                })
                              },
                            },
                          },
                          [_vm._v("Выйти из корзины")]
                        ),
                      ]),
                ])
              : _vm._e(),
          ])
        : _c("div", { staticClass: "card-body" }, [
            _vm.loaded
              ? _c("p", [_vm._v("У вас нет разрешенных сайтов для просмотра")])
              : _vm._e(),
          ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", { staticClass: "thead-dark" }, [
      _c("tr", [
        _c("th", [_vm._v("ID")]),
        _vm._v(" "),
        _c("th", [_vm._v("Имя")]),
        _vm._v(" "),
        _c("th", [_vm._v("Телефон")]),
        _vm._v(" "),
        _c("th", [_vm._v("Город")]),
        _vm._v(" "),
        _c("th", { attrs: { width: "300" } }, [_vm._v("Комментарий")]),
        _vm._v(" "),
        _c("th", [_vm._v("Препарат")]),
        _vm._v(" "),
        _c("th", { attrs: { width: "210" } }, [_vm._v("Статус")]),
        _vm._v(" "),
        _c("th", { attrs: { width: "130" } }, [_vm._v("Время")]),
        _vm._v(" "),
        _c("th", { attrs: { width: "170" } }, [_vm._v("Действия")]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }